export enum ReportStatus {
  COMPLETE,
  INCOMPLETE,
  WITHOUT_PAYING
}
